import '../../styles/elements/inputs/bitrix-users-selector.scss'

export default function BitrixUsersSelector(
    {className = "", title, selectedUsers, setSelectedUsers, BX24}
) {

    return (
        <div
            className={'user-selector' + className}
            onClick={() => BX24.selectUsers(setSelectedUsers)}
        >
            <p className={'user-selector-title'}>{title}</p>
            <div className={'user-selector-main1'}>
                {!!selectedUsers ? selectedUsers.map(selectedUser => <>
                    <div className={'selected-user1'}>
                        <h1>{selectedUser?.name ? selectedUser.name : ''}</h1>
                        <p>{selectedUser?.id ? 'ID: ' + selectedUser.id : ''}</p>
                    </div>
                </>) : <h1>Пользователи не выбраны</h1>}
            </div>
        </div>
    )
}
